import gButton from "@/components/g-button/g-button";
import gCard from "@/components/g-card/g-card.vue";
import gDateInput from "@/components/g-date-input/g-date-input";
import gForm from "@/components/g-form/g-form";
import gDataTable from "@/components/g-data-table/g-data-table";
import ClienteController from "@/shared/controllers/cliente/clienteController";
import ClienteDesenvolvimentoController from "@/shared/controllers/cliente/clienteDesenvolvimentoController";
import FiltroConsultarCliente from "@/shared/view-models/Filtros/FiltroConsultarCliente";
import CidadeController from "@/shared/controllers/cidade/cidadeController";
import EstadoController from "@/shared/controllers/estado/estadoController";
import PDFClienteInformacao from "./PDF/PDFClienteInformacao.vue";

import gPdf from "@/components/g-pdf/g-pdf.vue";
import Dashboard from "@/pages/Dashboard/Dashboard.vue";
import { useVuelidate } from "@vuelidate/core";
import { defineComponent } from "vue";
import EVENTS from "@/shared/events/events";
import {mask} from 'vue-the-mask'

const name = 'ClienteConsulta'
export default defineComponent({
  name,
  directives: {mask},
  setup() {
    return {
      v$: useVuelidate()
    }
  },

  components: {
    'g-button': gButton,
    'g-card': gCard,
    'g-date-input': gDateInput,
    'g-form': gForm,
    'g-data-table': gDataTable,
    'g-pdf': gPdf,
    PDFClienteInformacao,
    Dashboard
  },

  props: { },
  mounted () {
    this.EmpresaArray = this.$store.state.EmpresaArray;
    this.objFiltro.UnidadeId = null;

    this.PerfilMaterialArray = ClienteDesenvolvimentoController.getPerfilMateriais().PerfilMateriais;
    this.PotencialClienteArray = ClienteDesenvolvimentoController.getPotencial().PotencialArray;
    this.SegmentoArray = ClienteController.getClienteTipo().Segmentos;
    ClienteDesenvolvimentoController.getSituacao().requisicao.then((e)=>{
      this.SituacaoArray = e.data.splice(0,2);
    })
    this.EstadoArray = EstadoController.getEstados().EstadosArray;

    this.atualizaEmpresaRepresentante()

    this.mitt.on(EVENTS.trocaEmpresaRepresentante, () => {
      this.atualizaEmpresaRepresentante()
      this.ClienteArray = []
    })
  },

  updated () { },

  data () {
    return {
      checkboxConsultas: false,
      checkboxDoc: false,
      Cidade: '',
      CidadeArray: [],
      ClienteSelecionado: '',
      executarvisualizacao: 0,
      cnpj: '',
      codigo: '',
      EmpresaArray: [],
      EmpresaSelecionada: null,
      estado: '',
      EstadoArray:[],
      Id: null,
      nomeFantasia: '',
      objFiltro: new FiltroConsultarCliente(),
      pdfdownload: false,
      pdfvisualizacao: false,
      PerfilMaterialArray: [],
      PotencialClienteArray: [],
      pt1: true,
      razaoSocial: '',
      renderiza: false,
      SegmentoArray: [],
      SituacaoArray: [],

      Colunas : [
        //Campo dos dados , nome que aparece na página
        {field: 'codigoExterno', header: 'Código', width: '120px', ordena: true},
        {field: 'cnpj', header: 'CNPJ', width: '180px', ordena: true},
        {field: 'razaoSocial', header: 'Razão Social', width: '280px', ordena: true},
        {field: 'nomeFantasia', header: 'Nome Fantasia', width: '240px', ordena: true},
        {field: 'estadoCidade', header: 'Cidade / Estado', width: '200px', ordena: true},
        {field: 'dataInicialFormatadaTexto', header: 'Dt Inicial', width: '120px', ordena: true, ordenacao: 'dataInicial'},
        {field: 'clienteSituacaoTexto', header: 'Situacao', width: '200px', ordena: true},
        {field: 'curvaCliente', header: 'CV', width: '80px', ordena: true},
        {field: 'clienteTipoTexto', header: 'Segmento', width: '200px', ordena: true},
        {field: 'nomeEmpresa', header: 'Unidade', width: '180px', ordena: true},
        {field: 'perfilMaterialTexto', header: 'Perfil Material', width: '180px', ordena: true},
        {field: 'potencialClienteTexto', header: 'Potencial Cliente', width: '180px', ordena: true},
    ],
    Filtro: {
      'global': {value: null, matchMode: this.filtros.CONTAINS},
      'codigo': {value: null, matchMode: this.filtros.CONTAINS},
      'cnpj': {value: null, matchMode: this.filtros.CONTAINS},
      'razaoSocial': {value: null, matchMode: this.filtros.CONTAINS},
      'nomeFantasia' : {value: null, matchMode: this.filtros.CONTAINS},
      'segmentoFormat': {value: null, matchMode: this.filtros.CONTAINS},
      'estadoCidade': {value: null, matchMode: this.filtros.CONTAINS},
      'dataInicialFormatadaTexto' : {value: null, matchMode: this.filtros.CONTAINS},
      'clienteSituacaoTexto': {value: null, matchMode: this.filtros.CONTAINS},
      'curvaCliente': {value: null, matchMode: this.filtros.CONTAINS},
      'nomeEmpresa': {value: null, matchMode:this.filtros.CONTAINS},
      'perfilMaterialTexto' : {value: null, matchMode:this.filtros.CONTAINS},
      'potencialClienteTexto' : {value: null, matchMode: this.filtros.CONTAINS},
    },
    ClienteArray : [],
    UnidadeSelecionada: null,
    ClienteClicado: null
    }
  },

  methods: {
    gerarPdf(){
      this.executarvisualizacao++
    },
    imprimir(data)
    { 
      this.renderiza = true
      this.UnidadeSelecionada = data.unidadeId,
      this.ClienteClicado = data.id
    },
    editar(data){
      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + 'Cliente/EditarCliente',
        data:
        {
          cnpj: data.cnpj,
          UnidadeId: data.unidadeId,
          ClienteId: data.id
        }
      })
        .then((response) => {
          this.$store.state.cliente = response.data.data
          this.$store.commit('salvando');
          this.situacaoVindaDoBanco= response.data.data.clienteSituacao

          if(this.situacaoVindaDoBanco == 0)
          {
            this.$router.push('/ficha-cadastro')
          }
          else if (this.situacaoVindaDoBanco == 1)
          {
            this.$router.push('/cliente-em-desenvolvimento')
          }

        })

    },
    
    atualizaEmpresaRepresentante(){
      //this.objFiltro.UnidadeId = this.$store.state.empresaSelecionadaId;
      this.objFiltro.RepresentanteId = this.$store.state.representanteSelecionadoId;
    },

    buscarcidade(){
      this.axios({
          method: 'post',
          url: process.env.VUE_APP_WEB_API + 'Cidade/getbyestado',
          data: {
              id: this.objFiltro.EstadoId
          }
        })
          .then((response) => {
            this.CidadeArray = response.data.data


          })
          .catch(() => {
          });
  },
  setCidade () {
    let cidade = this.CidadeArray.find((Element) => Element.id == this.objFiltro.CidadeId)
    let estado = this.EstadoArray.find((Element) => Element.id == cidade.estadoId)

    if(estado)
      this.objFiltro.EstadoId = estado.id

  },


  popularDropDownEstado(){
    this.axios({
      method: 'get',
      url: process.env.VUE_APP_WEB_API + 'Estado/get',
    })
      .then((response) => {
        this.EstadoArray = response.data.data

      })
      .catch(() => {
      });
  },

    ClientGetAtivos(){
      this.ClientGetAtivos.getClientesAtivos().requisicao.then(res => this.ClienteArray =  res.data.data)
    },

    Grid () {
      this.pt1 = false
      this.getClientesByFiltro()
    },

    direcionaDetalhes(data){
      const rotaNovaAbaURL = this.$router.resolve({
        path: `cliente-informacao/${data.id}/${data.unidadeId}`
      }).href;
      
      window.open(rotaNovaAbaURL, '_blank');
    },

    getClientesByFiltro(){
      this.$isLoading(true)
      ClienteController.getClientesByFiltro(this.objFiltro).requisicao
        .then((response) =>{
            this.ClienteArray = response.data.data
        }).finally(() => this.$isLoading(false))

    },

    limparFiltro(){
      this.objFiltro = new FiltroConsultarCliente();
      this.clienteArray = []
      this.atualizaEmpresaRepresentante()
    },
    buscarCidadeSemEstado(event){

      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.CidadeArray = CidadeController.getByCidadeEstado(event).CidadeArray;
      }, 1000);
    },
  },

  computed: { },

});